export const RouteName = {
	HOME: 'home',
	CONTACT: 'contact',
	MAINTENANCE: 'maintenance',
	NOT_FOUND: 'notFound'
} as const;
